<template>
    <select v-model="diseaseType">
        <option :value="null">All</option>
        <option value="Asbestos Related Lung Cancer">Asbestos Related Lung Cancer</option>
        <option value="Bladder Cancer">Bladder Cancer</option>
        <option value="Kidney Cancer">Kidney Cancer</option>
        <option value="Laryngeal Cancer">Laryngeal Cancer</option>
        <option value="Leukemia">Leukemia</option>
        <option value="Liver Cancer">Liver Cancer</option>
        <option value="Mesothelioma">Mesothelioma</option>
        <option value="Nasal Cancer">Nasal Cancer</option>
        <option value="Skin Cancer">Skin Cancer</option>
    </select>
</template>

<script>

    export default {
        name: 'disease-type',
        computed: {
            diseaseType: {
                get() {
                    return this.$store.getters['dashboards/diseaseType'];
                },
                set(value) {
                    this.$store.dispatch('dashboards/updateFilter', {filter: 'diseaseType', value})
                },
            },
        }
    }
</script>



// WEBPACK FOOTER //
// DiseaseType.vue?2c0203e9